
/*
Note that most accessibility funcionality only works in chrome out of the box
*/

/*
  -- General
  -- Algolia
*/

jQuery(document).ready(function($) {
  if($(window).width() > 1024){

    /*
    9: "tab"
    27: "esc"
    37: "left"
    39: "right"
    13: "enter"
    38: "up"
    40: "down"
    */

    /*********************************************************/
    /****************** General Functions ********************/
    /*********************************************************/

    // keeps the search open when you tab.
    $('.twitter-typeahead input').off('blur');

    // Closes the search if you click off.
    $(document).click(function(e){
      if($(e.target).parents('.twitter-typeahead').length == 0){
        $('.twitter-typeahead pre').empty();

        if ($(".alg-searc-class").length > 0){
          $('.alg-searc-class').typeahead('val', '');
        }
      }
    });

    /*********************************************************/
    /****************** Algolia Functions ********************/
    /*********************************************************/

    // When clicking the close button clear the pre tag and the algolia search value.
    $('.searchToggle').on('click', function(){
      $('.twitter-typeahead pre').empty();

      if ($(".alg-searc-class").length > 0){
        $('.alg-searc-class').typeahead('val', '');
      }
    })

    function handleStep(e){

      // Variable for the current focused element
      currentElement = $(document.activeElement);

      // right and down arrow keys check
      if(e.which == 40 || e.which == 39){
        e.preventDefault();
        // if you are on the last element go back to the first
        if($('.focus-element').get($('.focus-element').index(currentElement) + 1) == undefined){
          $('.focus-element').get($('.focus-element').index(0)).focus();
        } else {
          // focus the next option in the dropdown
          $('.focus-element').get($('.focus-element').index(currentElement) + 1).focus();
        }
        // left and up arrow keys check
      } else if(e.which == 37 || e.which == 38){
        e.preventDefault();
        // go back one option in the dropdown
        $('.focus-element').get($('.focus-element').index(currentElement) - 1).focus();
        // esc key check
      } else if(e.which == 27){
        // clears and closes the algolia search.
        $('.twitter-typeahead pre').empty();

        if ($(".alg-searc-class").length > 0){
          $('.alg-searc-class').typeahead('val', '');
        }
      }
    }

    $('.tt-dropdown-menu').on('keydown', function(e){
      if($('.focus-element').length > 0){
        handleStep(e);
      }
    });
  }
});
